import { TApplicationState } from 'shared/types/redux';

export const newbuildingIdSelector = (state: TApplicationState) => {
  return state.newbuilding.id;
};
